import script from "./rulesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./rulesPage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__